import { atom } from "jotai";
import type { User } from "@/types/user";

export interface AuthState {
	user: User | null;
	isAuthenticated: boolean;
	loading: boolean;
}

export const authAtom = atom<AuthState>({
	user: null,
	isAuthenticated: false,
	loading: false,
});
